var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.375 14.75H32.5625V13.8125C32.5625 13.5639 32.4637 13.3254 32.2879 13.1496C32.1121 12.9738 31.8736 12.875 31.625 12.875C31.3764 12.875 31.1379 12.9738 30.9621 13.1496C30.7863 13.3254 30.6875 13.5639 30.6875 13.8125V14.75H21.3125V13.8125C21.3125 13.5639 21.2137 13.3254 21.0379 13.1496C20.8621 12.9738 20.6236 12.875 20.375 12.875C20.1264 12.875 19.8879 12.9738 19.7121 13.1496C19.5363 13.3254 19.4375 13.5639 19.4375 13.8125V14.75H16.625C16.1277 14.75 15.6508 14.9475 15.2992 15.2992C14.9475 15.6508 14.75 16.1277 14.75 16.625V35.375C14.75 35.8723 14.9475 36.3492 15.2992 36.7008C15.6508 37.0525 16.1277 37.25 16.625 37.25H35.375C35.8723 37.25 36.3492 37.0525 36.7008 36.7008C37.0525 36.3492 37.25 35.8723 37.25 35.375V16.625C37.25 16.1277 37.0525 15.6508 36.7008 15.2992C36.3492 14.9475 35.8723 14.75 35.375 14.75ZM19.4375 16.625V17.5625C19.4375 17.8111 19.5363 18.0496 19.7121 18.2254C19.8879 18.4012 20.1264 18.5 20.375 18.5C20.6236 18.5 20.8621 18.4012 21.0379 18.2254C21.2137 18.0496 21.3125 17.8111 21.3125 17.5625V16.625H30.6875V17.5625C30.6875 17.8111 30.7863 18.0496 30.9621 18.2254C31.1379 18.4012 31.3764 18.5 31.625 18.5C31.8736 18.5 32.1121 18.4012 32.2879 18.2254C32.4637 18.0496 32.5625 17.8111 32.5625 17.5625V16.625H35.375V20.375H16.625V16.625H19.4375ZM35.375 35.375H16.625V22.25H35.375V35.375Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.9a31472478a1f006f0b6a9dc0326d7f4.svg";
export { ForwardRef as ReactComponent };